<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "WalletConfig",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'walletConfig:add',
        update: 'walletConfig:update',
        delete: 'walletConfig:delete',
        deleteBatch: 'walletConfig:deleteBatch'
      },
      url: {
        get: '/walletConfig/listByCondition',
        add: '/walletConfig/add',
        update: '/walletConfig/update',
        delete: '/walletConfig/delete/',
        delete_batch: '/walletConfig/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '',
      }, {
        field: 'firstChargeMoney',
        label: '首充金额',
        show: true,
        width: '',
      }, {
        field: 'giveAway',
        label: '赠送金额',
        show: true,
        width: '',
      }, {
        field: 'withdrawalNum',
        label: '提现次数',
        show: true,
        width: '',
      },{
        field: 'minimumAmount',
        label: '最低提现金额',
        show: true,
        width: '',
      },
        {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '添加钱包配置信息',
        updateTitle: '修改钱包配置信息',
        toTree:false,
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择',
          rules: [{
            message: '请选择代理', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'firstChargeMoney',
          label: '首充金额',
          type: 'textarea',
          placeholder: '首充金额',
          rules: [{message: '请输入首充金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'giveAway',
          label: '赠送金额',
          type: 'textarea',
          placeholder: '赠送金额',
          rules: [{message: '请输入赠送金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'withdrawalNum',
          label: '提现次数',
          type: 'textarea',
          placeholder: '提现次数',
          rules: [{message: '请输入提现次数', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'minimumAmount',
          label: '最低提现金额',
          type: 'textarea',
          placeholder: '最低提现金额',
          rules: [{message: '请输入最低提现金额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }
        ],
      }
    }
  }
}
</script>

<style scoped>

</style>
